import { createStyles, Theme } from "@material-ui/core";
export const questionCardStyle = (theme: Theme) =>
    createStyles({
        root: {
            flex: 'grow'
        },
        mb1x: {
            marginBottom: theme.spacing.unit
        },
        questionInfo: {
            border: `1px solid ${theme.palette.grey[300]}`,
            "& > div": {
                padding: `0 ${theme.spacing.unit}px`
            },
            "& > div:first-child": {
                paddingTop: theme.spacing.unit,
                paddingBottom: theme.spacing.unit,
                //borderRight: `1px solid ${theme.palette.grey[300]}`
            }
        },
        questionParagraph: {
            maxWidth: 535,
            '& >p': {
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                margin: '0',
            },
        },
        pTagmargin:{
            '& >p:first-child':{
                margin:'0',
            },
        }
    });